document.addEventListener('DOMContentLoaded', function () {
  window.dataLayer = window.dataLayer || [];

  // Button click tracking
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-track-click]');
    if (!btn) return;

    window.dataLayer.push({
      event: 'custom_button_click',
      button_name: btn.getAttribute('data-track-click'),
      button_location: btn.getAttribute('data-track-location') || ''
    });
  });

  // Klaviyo popup subscribe tracking
  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail.type === 'submit') {
      window.dataLayer.push({
        event: 'klaviyo_subscribe',
        form_id: e.detail.formId,
        form_title: e.detail.metaData && e.detail.metaData.$source ? e.detail.metaData.$source : ''
      });
    }
  });
});